import { FETCH_DEALS_WITH_FORECAST_CATEGORIES_SUCCEEDED, FETCH_DEALS_WITH_FORECAST_CATEGORIES_FAILED } from './ActionTypes';
import { fetchDealsWithForecastCategories as fetchDealsWithForecastCategoriesRequest } from '../api/dealsApi';
import { logRavenException } from 'ui-deal-management-components-lib/utils/ravenWrapperUtil';
export function fetchDealsWithForecastCategories() {
  return dispatch => {
    fetchDealsWithForecastCategoriesRequest().then(results => {
      dispatch({
        type: FETCH_DEALS_WITH_FORECAST_CATEGORIES_SUCCEEDED,
        payload: results
      });
    }).catch(error => {
      dispatch({
        type: FETCH_DEALS_WITH_FORECAST_CATEGORIES_FAILED
      });
      logRavenException(error, 'Fetch deals with forecast categories');
    });
  };
}